export default __webpack_public_path__ + "static/media/delete.fd0809d3.svg";